// ✅ Play only the active slide's video, pause the rest
function playActiveVideoSlide(swiper) {
  swiper.slides.forEach((slideEl) => {
    const video = slideEl.querySelector("video");
    if (!video) return;
    if (slideEl.classList.contains("swiper-slide-active")) {
      video.play().catch(() => {});
    } else {
      video.pause();
    }
  });
}

// ✅ Shared config for card media swipers (manual horizontal swipe, no autoplay)
// loop mode needs enough real slides or Swiper's slide-cloning causes a
// visible jump/reset on the first swipe — only loop when there's enough.
function cardSwiperConfig(paginationEl, slideCount = 0) {
  return {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: slideCount > 2,
    speed: 300,
    effect: "slide",
    autoplay: false,
    watchOverflow: true,
    grabCursor: true,
    preloadImages: true,
    followFinger: true,
    touchRatio: 1,
    resistanceRatio: 0.85,
    threshold: 0,
    pagination: {
      el: paginationEl,
      type: "bullets",
      clickable: true,
    },
    initialSlide: 0,
    on: {
      init: function () {
        if (this.slides.length <= 1 && paginationEl) {
          paginationEl.style.display = "none";
        }
        playActiveVideoSlide(this);
      },
      slideChangeTransitionEnd: playActiveVideoSlide,
    },
  };
}

// ✅ Media Swiper Initializer
function initMediaSwipers(scope = document) {
  scope.querySelectorAll(".card-wrapper").forEach((el) => {
    const media_swiper = el.querySelector(".media-swiper");
    if (!media_swiper) return;
    if (media_swiper.classList.contains("swiper-initialized")) return; // prevent double init

    const slideCount = media_swiper.querySelectorAll(".swiper-slide").length;
    new Swiper(media_swiper, cardSwiperConfig(el.querySelector(".media-swiper-pagination"), slideCount));
  });
}

// ✅ Swatch Initializer
function initializeSwatches(scope = document) {
  const swatchBlocks = scope.querySelectorAll(".card-wrapper .color-swatches");

  swatchBlocks.forEach((block) => {
    block
      .querySelectorAll(".card-wrapper .quick-add__submit.button")
      .forEach((btn) => {
        if (!btn.hasAttribute("aria-haspopup")) {
          btn.setAttribute("aria-haspopup", "dialog");
        }
      });

    const firstLabel = block.querySelector(".swatch-label");
    if (!firstLabel) return;

    const swatch = firstLabel.querySelector(".swatch");
    const selectedColor = swatch ? swatch.getAttribute("title") : null;
    const productWishlistButton = block
      .closest(".card-wrapper")
      ?.querySelector(".wishlist_button");

    if (productWishlistButton && selectedColor) {
      productWishlistButton.setAttribute(
        "data-selected-variant-value",
        selectedColor
      );
    }

    firstLabel.classList.add("active");
    const swatchRadio = firstLabel.querySelector(".swatch-radio");
    if (swatchRadio) {
      swatchRadio.checked = true;
      firstLabel.click();
    }
  });
}

// ✅ Wait until swatches load
function waitForSwatchesToLoad(retries = 10, scope = document) {
  requestIdleCallback(() => {
    const swatches = scope.querySelectorAll(
      ".card-wrapper .color-swatches .swatch-label"
    );

    if (swatches.length) {
      initializeSwatches(scope);
    } else if (retries > 0) {
      setTimeout(() => waitForSwatchesToLoad(retries - 1, scope), 100);
    }
  }, { timeout: 200 });
}

// ✅ Safe init
function initAll(scope = document) {
  waitForSwatchesToLoad(10, scope);
  initMediaSwipers(scope);
}

// ✅ Global expose so pagination loader can call it
window.initAll = initAll;

if (document.readyState === "loading") {
  window.addEventListener("DOMContentLoaded", () => initAll());
} else {
  initAll();
}

// ✅ Re-init after Shopify section render
document.addEventListener("shopify:section:load", (e) => {
  initAll(e.target);
});

// ✅ Re-init after async content lands (e.g. product-recommendations,
// recently-viewed, wishlist, search results replacing their innerHTML)
if (typeof MutationObserver !== "undefined") {
  let cardObserverTimer;
  const cardObserver = new MutationObserver(() => {
    clearTimeout(cardObserverTimer);
    cardObserverTimer = setTimeout(() => initAll(), 200);
  });
  cardObserver.observe(document.body, { childList: true, subtree: true });
}

// ✅ Swatch click logic (delegation + swiper refresh)
document.addEventListener("click", (e) => {
  const label = e.target.closest(
    ".card-wrapper .color-swatches .swatch-label"
  );
  if (!label) return;

  const radio = label.querySelector(".swatch-radio");
  const swatch = label.querySelector(".swatch");
  const selectedColor = swatch ? swatch.getAttribute("title") : null;
  const variantId = radio ? radio.value : null;
  const cardWrapper = label.closest(".card-wrapper");
  const addToCartForm = cardWrapper?.querySelector(".quick-add form");
  const inputCart = addToCartForm?.querySelector("input[name='id']");
  const wishlistButton = cardWrapper?.querySelector(".wishlist_button");
  const btnCart = cardWrapper?.querySelector(
    ".card-wrapper .quick-add__submit.button"
  );


  if (radio) {
    radio.checked = true;
    radio.dispatchEvent(new Event("change", { bubbles: true }));
  }

  if (inputCart && variantId) {
    inputCart.value = variantId;
    inputCart.dispatchEvent(new Event("change", { bubbles: true }));
  }
 

  if (wishlistButton && variantId) {
    wishlistButton.setAttribute("data-product-variant-id", variantId);
    if (selectedColor)
      wishlistButton.setAttribute("data-selected-variant-value", selectedColor);
  }
  if (selectedColor) {
    cardWrapper.querySelector(".selected_value").textContent = selectedColor.replace("Yellow", "");
  }

  if (btnCart) {
    btnCart.disabled = !variantId;
  }

  cardWrapper.querySelectorAll(".product-variant-id").forEach(inp => {
    inp.value = variantId;
    inp.dispatchEvent(new Event("change", { bubbles: true }));
  });

  label.parentElement
    .querySelectorAll(".swatch-label")
    .forEach((sibling) => sibling.classList.remove("active"));
  label.classList.add("active");

  // ✅ Replace images + refresh swiper
  const productVariantsData = cardWrapper?.querySelector(
    "#product-variants-data"
  )?.textContent;

  if (productVariantsData) {
    requestIdleCallback(() => {
      const productVariants = JSON.parse(productVariantsData);
      const selectedVariant = productVariants.find((v) => v.id == variantId);

      if (selectedVariant?.variant_image?.length) {
        const swiperContainer = cardWrapper.querySelector(".media-swiper");

        if (swiperContainer) {
          // ✅ Swiper path — rebuild slides (images + video) for the selected variant
          // Skip the rebuild if this is the same variant already rendered server-side
          // (avoids destroying/recreating the swiper right after page load, which was
          // causing the multi-second delay before swipe worked).
          const isInitialVariant = swiperContainer.dataset.variantId === String(variantId);

          if (isInitialVariant && swiperContainer.swiper) {
            // no-op: initial swiper already matches this variant's media
          } else {
          const swiperWrapper = swiperContainer.querySelector(".swiper-wrapper");
          const paginationEl = cardWrapper.querySelector(".media-swiper-pagination");

          if (swiperWrapper) {
            if (swiperContainer.swiper) {
              swiperContainer.swiper.destroy(true, true);
            }

            swiperWrapper.innerHTML = "";

            selectedVariant.variant_image.forEach((mediaItem) => {
              const slide = document.createElement("div");
              slide.classList.add("swiper-slide");

              if (
                mediaItem &&
                typeof mediaItem === "object" &&
                mediaItem.media_type === "video" &&
                mediaItem.sources
              ) {
                const video = document.createElement("video");
                video.autoplay = false;
                video.muted = true;
                video.loop = true;
                video.playsInline = true;
                video.setAttribute("playsinline", "");
                video.setAttribute("muted", "");
                const poster = mediaItem.preview_image && mediaItem.preview_image.src;
                if (poster) video.poster = poster;

                mediaItem.sources
                  .filter((source) => source.mime_type && source.mime_type.includes("video"))
                  .forEach((source) => {
                    const sourceEl = document.createElement("source");
                    sourceEl.src = source.url;
                    sourceEl.type = source.mime_type;
                    video.appendChild(sourceEl);
                  });

                slide.appendChild(video);
              } else if (typeof mediaItem === "string") {
                const sep = mediaItem.includes("?") ? "&" : "?";
                const img = document.createElement("img");
                img.src = `${mediaItem}${sep}width=533`;
                img.srcset = [360, 533, 720, 940, 1066]
                  .map((w) => `${mediaItem}${sep}width=${w} ${w}w`)
                  .join(", ");
                img.sizes = "(min-width: 768px) 533px, 100vw";
                img.loading = "lazy";
                img.className = "motion-reduce";

                slide.appendChild(img);
              }

              swiperWrapper.appendChild(slide);
            });

            new Swiper(swiperContainer, cardSwiperConfig(paginationEl, selectedVariant.variant_image.length));
          }
          }
        } else {
          // ✅ Fallback path — plain two-image swap for products without swiper markup
          const primaryImage = selectedVariant.variant_image[0];
          const secondaryImage =
            selectedVariant.variant_image[2] || primaryImage;

          const images = cardWrapper.querySelectorAll(".media img");

          if (images.length >= 2) {
            images[0].setAttribute("src", primaryImage);
            images[0].setAttribute("srcset", primaryImage);

            images[1].setAttribute("src", secondaryImage);
            images[1].setAttribute("srcset", secondaryImage);
          }
        }
      }
    }, { timeout: 200 });
  }
});

// ✅ Toggle Menu via Delegation
document.addEventListener("click", (e) => {
  const btn = e.target.closest(".toggle-btn");
  if (!btn) return;

  const card = btn.closest(".card-wrapper");
  const menuContainer = card?.querySelector(".menu-container");
  const mediaAfter = card?.querySelector(".card__media");

  if (menuContainer && mediaAfter) {
    menuContainer.classList.toggle("active");
    mediaAfter.classList.toggle("active");
  }
});
